//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import userChecks from '~/mixins/userChecks';
import { queries } from '~/helpers/defaultQueries';
export default {
  mixins: [userChecks],
  async fetch() {
    await this.$store.dispatch(
      'resourcesStore/getResources',
      queries.newestRecurringVideos
    );
  },
  components: {
    dummyItem: () => import('~/components/content/dummy/video_dummy.vue'),
  },
  data() {
    return {
      backEnd: true,
      forwardEnd: false,
    };
  },
  computed: {
    ...mapState({
      newestRecurringVideos: ({ resourcesStore: { newestRecurringVideos } }) =>
        newestRecurringVideos,
      loading: ({ resourcesStore: { loading } }) => loading,
    }),
  },
};
